export const STORAGE_KEY = 'pocket-pet-state-v1';

const clamp = value => Math.max(0, Math.min(100, value));

export function createPet(name) {
  const now = Date.now();
  return {
    version: 1,
    name: name.trim(),
    bornAt: now,
    lastUpdated: now,
    hunger: 86,
    happiness: 82,
    health: 100,
    alive: true,
    lastAction: 'born'
  };
}

export function loadPet() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
}

export function savePet(pet) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(pet));
  } catch {}
}

export function clearPet() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
}

export function advancePet(pet, now = Date.now()) {
  if (!pet || !pet.alive) return pet;
  const elapsedHours = Math.max(0, now - pet.lastUpdated) / 3600000;
  if (elapsedHours <= 0) return pet;

  const hunger = clamp(pet.hunger - elapsedHours * 5.5);
  const happiness = clamp(pet.happiness - elapsedHours * 2.8);
  let health = pet.health;

  if (hunger < 20) health -= elapsedHours * (20 - hunger) * 0.7;
  if (happiness < 15) health -= elapsedHours * (15 - happiness) * 0.22;
  if (hunger >= 45 && happiness >= 35) health += elapsedHours * 1.2;

  health = clamp(health);

  return {
    ...pet,
    hunger,
    happiness,
    health,
    alive: health > 0,
    lastUpdated: now
  };
}

export function feedPet(pet) {
  const current = advancePet(pet);
  if (!current?.alive) return current;
  return {
    ...current,
    hunger: clamp(current.hunger + 34),
    happiness: clamp(current.happiness + 4),
    health: clamp(current.health + 2),
    lastAction: 'feed',
    lastUpdated: Date.now()
  };
}

export function playWithPet(pet) {
  const current = advancePet(pet);
  if (!current?.alive) return current;
  return {
    ...current,
    hunger: clamp(current.hunger - 7),
    happiness: clamp(current.happiness + 31),
    health: clamp(current.health + 1),
    lastAction: 'play',
    lastUpdated: Date.now()
  };
}

export function getMood(pet) {
  if (!pet?.alive) return 'dead';
  if (pet.health < 30) return 'sick';
  if (pet.hunger < 25) return 'hungry';
  if (pet.happiness < 25) return 'sad';
  if (pet.hunger > 70 && pet.happiness > 70) return 'happy';
  return 'calm';
}

export function getAgeLabel(pet, now = Date.now()) {
  if (!pet) return '';
  const hours = Math.max(0, now - pet.bornAt) / 3600000;
  if (hours < 1) return `${Math.max(1, Math.floor(hours * 60))} min`;
  if (hours < 24) return `${Math.floor(hours)} h`;
  const days = Math.floor(hours / 24);
  return `${days} d`;
}
